const FIELD_LABELS = {
  name: 'Nome',
  email: 'E-mail',
  password: 'Senha',
  procedure: 'Procedimento',
  value: 'Valor',
  duration_minutes: 'Tempo estimado',
  payment_type: 'Tipo de atendimento',
}

const NETWORK_ERROR_MESSAGE =
  'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'

function fieldLabel(loc = []) {
  const field = [...loc].reverse().find((part) => typeof part === 'string' && part !== 'body')
  return FIELD_LABELS[field] || field || 'Campo'
}

function translateValidationItem(item) {
  if (!item || typeof item !== 'object') {
    return typeof item === 'string' ? item : null
  }

  const label = fieldLabel(item.loc)
  const type = item.type
  const ctx = item.ctx || {}

  switch (type) {
    case 'missing':
      return `${label} é obrigatório.`
    case 'string_too_short':
      return `${label} deve ter pelo menos ${ctx.min_length} caracteres.`
    case 'string_too_long':
      return `${label} deve ter no máximo ${ctx.max_length} caracteres.`
    case 'greater_than_equal':
      return `${label} deve ser maior ou igual a ${ctx.ge}.`
    case 'greater_than':
      return `${label} deve ser maior que ${ctx.gt}.`
    case 'less_than_equal':
      return `${label} deve ser menor ou igual a ${ctx.le}.`
    case 'less_than':
      return `${label} deve ser menor que ${ctx.lt}.`
    case 'int_parsing':
    case 'float_parsing':
    case 'decimal_parsing':
      return `${label} deve ser um número válido.`
    case 'bool_parsing':
      return `${label} é inválido.`
    case 'literal_error':
      if (label === 'Tipo de atendimento') {
        return 'Tipo de atendimento deve ser Particular ou Convênio.'
      }
      return `${label} possui um valor inválido.`
    case 'value_error':
      if (String(item.msg || '').toLowerCase().includes('email')) {
        return 'Informe um e-mail válido.'
      }
      return `${label} é inválido.`
    case 'string_type':
      return `${label} deve ser um texto.`
    default:
      break
  }

  if (String(item.msg || '').toLowerCase().includes('email')) {
    return 'Informe um e-mail válido.'
  }

  return `${label} é inválido.`
}

export function formatApiError(payload, fallback = 'Não foi possível concluir a operação.') {
  const detail = payload?.detail

  if (typeof detail === 'string' && detail.trim()) {
    return detail
  }

  if (Array.isArray(detail)) {
    const messages = detail.map(translateValidationItem).filter(Boolean)
    if (messages.length) {
      return [...new Set(messages)].join(' ')
    }
  }

  return fallback
}

export function formatRequestError(error, fallback = 'Não foi possível concluir a operação.') {
  if (!error) return fallback

  const message = error.message || ''
  if (
    error.name === 'TypeError' ||
    /failed to fetch|networkerror|load failed|network request failed/i.test(message)
  ) {
    return NETWORK_ERROR_MESSAGE
  }

  return message || fallback
}

export async function readErrorPayload(response) {
  return response.json().catch(() => null)
}
